import CollapseIcon from "@redotech/redo-icons/collapse-01.svg";
import { Step } from "@redotech/redo-model/return-flow";
import { BlockLayout } from "@redotech/redo-web/flowchart";
import React from "react";
import { StepType, StepTypeDetailsProps } from "../step";

export interface CombineLabelState {
  customTitle?: string;
}

export namespace CombineLabelState {
  export function valid(_state: CombineLabelState): boolean {
    return true;
  }
}

export const COMBINE_LABEL = (
  Details: React.ComponentType<StepTypeDetailsProps<CombineLabelState>>,
): StepType<CombineLabelState, Step.CombineLabel> => ({
  layout() {
    return BlockLayout.FULL;
  },
  empty: {},

  title: "Combine label",

  customTitle: (state) => state.customTitle,

  description: (state, team) => {
    const methods = [];
    const skuGroupingEnabled =
      team?.settings.returns?.labelCombination?.combineLabelsSkuGroups
        ?.enabled ?? false;
    const sameFulfillmentEnabled =
      team?.settings.returns?.labelCombination
        ?.onlyCombineLabelsFromSameFulfillment ?? false;

    if (skuGroupingEnabled) {
      methods.push("SKU grouping");
    }
    if (sameFulfillmentEnabled) {
      methods.push("Same fulfillment");
    }
    return `Combine method\n${methods.map((m) => `${m}`).join("\n")}`;
  },

  Icon: CollapseIcon,
  iconColor: "success",

  Details(props) {
    return <Details {...props} />;
  },

  downstream: () => [],

  maxDownstream: () => 0,

  fromModel: (model) => ({ customTitle: model.customTitle }),

  toModel: (state) => ({
    type: Step.COMBINE_LABEL,
    customTitle: state.customTitle,
  }),

  valid: (state) => CombineLabelState.valid(state),

  stepDeleted: (state) => state,
});
